import React, { useEffect, useRef } from "react"
import { navigate } from "gatsby"
import { useLocation } from "@reach/router"

export const PageTransition = ({ children }) => {
	const transitionRef = useRef(null)
	const { pathname } = useLocation()

	useEffect(() => {
		const transitionWrapper = transitionRef.current
		if (!transitionWrapper) return

		function fadeOutPage(event, path) {
			if (path === null || pathname === null) return
			event.preventDefault()
			if (pathname === path) return
			if (!pathname.includes("/press/") && !path.includes("/press")) return navigate(path)
			transitionWrapper.classList.remove("fade--in")
			transitionWrapper.classList.add("fade--out")
			setTimeout(() => navigate(path), 750)
		}

		function fadeInPage() {
			window.scrollTo(0, 0)
			transitionWrapper.classList.contains("fade--out") && transitionWrapper.classList.remove("fade--out")
			transitionWrapper.classList.add("fade--in")
		}

		fadeInPage()

		const links = document.querySelectorAll("a")

		links.forEach(link => {
			if (link.hasAttribute("target")) return
			const path = link.getAttribute("href")
			link.addEventListener("click", e => fadeOutPage(e, path))
		})

		return () => {
			links.forEach(link => {
				const path = link.getAttribute("href")
				link.removeEventListener("click", e => fadeOutPage(e, path))
			})
		}
	}, [pathname])

	return (
		<div className={`page--transition ${pathname.includes("/press") ? "fade--in" : ""}`} ref={transitionRef}>
			{children}
		</div>
	)
}
